import React from 'react'

import IconSort from '../icons/IconSort'

const TableHeader = (props) => {
  const { columns, padding } = props


  const classGenerator = (column) => {
    let className = 'table__header-item'
    if (column.flexGrow) {
      className += ' ' + column.flexGrow
    }
    if (column.isSortable) {
      className += ' table__header-item--sortable'
    }
    return className
  }


  const specificPadding = () => {
    return padding ? { paddingLeft: padding } : {}
  }

  return (
    <div className="table__header">
      <ul
        className="table__header-list"
        style={specificPadding()}
      >
        {columns.map(column => (
          <li onClick={() => props.onSort(column)} className={classGenerator(column)} key={column.name}>
            <span className={"table__header-cell" + (column.name === 'Select all' || column.name === 'Unselect all' ? ' link' : '')}>
              {column.name}
              {column.isSortable && <IconSort className="table__header-cell-icon" />}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default TableHeader
